<template>
  <nav
    class="
      navbar navbar-vertical
      fixed-left
      navbar-expand-md bg-transparent
    "
    id="sidenav-main"
  >
    <div class="container-fluid">
      <!--Toggler-->
      <navbar-toggle-button @click.native="showSidebar">
       <i class="ri-menu-fill table-text"></i>
      </navbar-toggle-button>
      <router-link class="navbar-brand" to="/">
        <img
          :src="require('@/assets/favicon.png')"
          class="navbar-brand-img"
          alt="..."
        />
      </router-link>

      <slot name="mobile-right">
        <ul class="nav align-items-center d-md-none">
          <base-dropdown class="nav-link pr-0">
            <div class="media align-items-center" slot="title">
              <div class="media-body mr-2">
                <span class="mb-0 text-sm font-weight-bold"
                  ><img :src="flag" width="20" height="15"
                /></span>
              </div>
            </div>

            <template>
              <a class="dropdown-item" @click="changeLang('en')">
                <span
                  ><img src="/img/flags/en.png" width="15" height="13" />
                  {{ $t("english") }}</span
                >
              </a>
              <a class="dropdown-item" @click="changeLang('es')">
                <span
                  ><img src="/img/flags/es.jpg" width="15" height="13" />
                  {{ $t("spanish") }}</span
                >
              </a>
              <a class="dropdown-item" @click="changeLang('de')">
                <span
                  ><img src="/img/flags/de.png" width="15" height="13" />
                  {{ $t("germany") }}</span
                >
              </a>
            </template>
          </base-dropdown>
          <base-dropdown class="nav-item" position="right">
            <a slot="title" class="nav-link" href="#" role="button">
              <div class="media align-items-center">
                <span class="avatar avatar-sm rounded-circle bg-primary">
                  {{ avatar }}
                  <!-- <img alt="Image placeholder" src="img/theme/team-1-800x800.jpg"> -->
                </span>
              </div>
            </a>

            <router-link to="/profile" class="dropdown-item">
              <i class="ni ni-single-02 table-text"></i>
              <span class="table-text">{{ $t("my_profile") }}</span>
            </router-link>
             <div @click="darkMode = !darkMode" class="dropdown-item">
              <i class="table-text" :class="darkMode ? 'ri-toggle-fill' : 'ri-toggle-line'"></i>
              <span class="table-text">Modo Dark</span>
            </div>
            <div class="dropdown-item" @click="$refs.modalsReferralsSidebar.show()">
              <i class="table-text ri-vip-crown-2-line"></i>
              <span class="table-text">{{$t('my_referrals')}}</span>
            </div>
            <div class="dropdown-divider"></div>
            <div @click="logout()" class="dropdown-item">
              <i class="ni ni-user-run table-text"></i>
              <span class="table-text">{{ $t("logout") }}</span>
            </div>
          </base-dropdown>
        </ul>
      </slot>
      <slot></slot>
      <div
        v-show="$sidebar.showSidebar"
        class="navbar-collapse collapse show"
        id="sidenav-collapse-main"
      >
        <div class="navbar-collapse-header d-md-none">
          <div class="row">
            <div class="col-6 collapse-brand">
              <router-link to="/">
                <img :src="logo" />
              </router-link>
            </div>
            <div class="col-6 collapse-close">
              <navbar-toggle-button
                @click.native="closeSidebar"
              ></navbar-toggle-button>
            </div>
          </div>
        </div>

        <ul class="navbar-nav">
          <slot name="links"> </slot>
        </ul>
      </div>
    </div>
     <ModalReferrals ref="modalsReferralsSidebar" />
  </nav>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import NavbarToggleButton from "@/components/NavbarToggleButton";
import ModalReferrals from "@/views/Profile/MyReferralsModal.vue";
export default {
  name: "sidebar",
  components: {
    NavbarToggleButton,
    ModalReferrals
  },
  props: {
    logo: {
      type: String,
      default: "img/brand/green.png",
      description: "Sidebar app logo",
    },
    autoClose: {
      type: Boolean,
      default: true,
      description:
        "Whether sidebar should autoclose on mobile when clicking an item",
    },
  },
  data(){
    return{
      darkMode: false,
    }
  },
  watch: {
    darkMode: function () {
      // add/remove class to/from html tag
      let htmlElement = document.documentElement;
      if (this.darkMode) {
        localStorage.setItem("theme", "dark");
        htmlElement.setAttribute("theme", "dark");
      } else {
        localStorage.setItem("theme", "light");
        htmlElement.setAttribute("theme", "light");
      }
    },
  },
  mounted() {
    this.$i18n.locale = localStorage.getItem('lang')
    document.title = "M2M";

    // set 'app-background' class to body tag
    let bodyElement = document.body;
    bodyElement.classList.add("app-background");

    // check for active theme
    let htmlElement = document.documentElement;
    let theme = localStorage.getItem("theme");

    if (theme === "dark") {
      htmlElement.setAttribute("theme", "dark");
      this.darkMode = true;
    } else {
      htmlElement.setAttribute("theme", "light");
      this.darkMode = false;
    }
  },
  provide() {
    return {
      autoClose: this.autoClose,
    };
  },
  methods: {
    closeSidebar() {
      this.$sidebar.displaySidebar(false);
    },
    showSidebar() {
      this.$sidebar.displaySidebar(true);
    },
    async logout() {
      const res = await this.$store.dispatch("logout");
      if (res.status === 202) {
        this.$router.push("/login");
      }
    },
    ...mapActions({
      changeLanguage: "auth/updateLang",
    }),
     async changeLang(lang) {
      this.$i18n.locale = lang;
      localStorage.setItem("lang", lang);
      this.$toast.success(this.$t("language_changed"), {
        position: "top-right",
      });
    },
    darkThemeSwitch() {
      const res = localStorage.getItem("theme");
      if (res === "dark") {
        this.$store.commit("SET_THEME", "light");
        localStorage.setItem("theme", "light");
      } else {
        this.$store.commit("SET_THEME", "dark");
        localStorage.setItem("theme", "dark");
      }
      this.darkTheme = !this.darkTheme;
    },
  },
  beforeDestroy() {
    if (this.$sidebar.showSidebar) {
      this.$sidebar.showSidebar = false;
    }
  },
  computed: {
    ...mapGetters({
      user: "user",
      getTheme : 'getTheme'
    }),
     theme(){
         if(this.getTheme === 'dark'){
           return true
         }else{
          return false
         }
      },
    avatar() {
      if (this.user) {
        return `${this.user.name.charAt()}${this.user.lastname.charAt()}`;
      }
    },
    flag() {
      const locale = this.$i18n.locale;
      if (locale === "en") return "/img/flags/en.png";
      else if (locale === "es") return "/img/flags/es.jpg";
      else if (locale === "de") return "img/flags/de.png";
      else return "/img/flags/en.png";
    },
  },
};
</script>
<style scoped>
.navbar-vertical .navbar-brand-img,
.navbar-vertical .navbar-brand > img {
  max-width: 100%;
  max-height: 3.2rem !important;
}
@media (min-width: 768px) {
  .navbar-vertical.navbar-expand-md .navbar-brand-img {
    max-height: 5rem !important;
  }
}
</style>
